import Avito, { AvitoSchema } from './Avito'
import Adgram, { AdgramSchema } from './Adgram'
import Adsmarket, { AdsmarketSchema } from './Adsmarket'
import Appnext, { AppnextSchema } from './Appnext'
import BigoAds, { BigoAdsSchema } from './BigoAds'
import DirectAdvert, { DirectAdvertSchema } from './DirectAdvert'
import Facebook, { FacebookSchema } from './Facebook'
import FacebookHighRisk, { FacebookHighRiskSchema } from './FacebookHighRisk'
import GoogleAds, { GoogleAdsSchema } from './GoogleAds'
import Mobidriven, { MobidrivenSchema } from './Mobidriven'
import MytargetInt, { MytargetIntSchema } from './Mytargetint'
import Otm, { OtmSchema } from './Otm'
import Pornhub, { PornhubSchema } from './Pornhub'
import Snapchat, { SnapchatSchema } from './Snapchat'
import Taboola, { TaboolaSchema } from './Taboola'
import TargetMail, { TargetMailSchema } from './TargetMail'
import TelegramAds, { TelegramAdsSchema } from './TelegramAds'
import Tiktok, { TiktokSchema } from './Tiktok'
import Vk, { VkSchema } from './Vk'
import VkAds, { VkAdsSchema } from './VkAds'
import Yahoo, { YahooSchema } from './Yahoo'
import Yandex, { YandexSchema } from './Yandex'
import YandexBusiness, { YandexBusinessSchema } from './YandexBusiness'
import YandexZen, { YandexZenSchema } from './YandexZen'
import Zeropark, { ZeroparkSchema } from './Zeropark'
import YandexGeo, { YandexGeoSchema } from './YandexGeo'
import OzonPerformance, { OzonPerformanceSchema } from './OzonPerformance'
import PetalAds, { PetalAdsSchema } from './PetalAds'
import MiAds, { MiAdsSchema } from './MiAds'
import AppleSearchAds, { AppleSearchAdsSchema } from './AppleSearchAds'
import UnityAds, { UnityAdsSchema } from 'modules/Forms/Account/Create/UnityAds'
import MicrosoftAds, { MicrosoftAdsSchema } from './MicrosoftAds'
import WowBlogger, { WowBloggerSchema } from './WowBlogger'
import VkAdBlogger, {
  VkAdBloggerSchema,
} from 'modules/Forms/Account/Create/VkAdBlogger'
import GoogleAdsHighRisk, {
  GoogleAdsHighRiskSchema,
} from 'modules/Forms/Account/Create/GoogleAdsHighRisk'
import TwoGis, { TwoGisSchema } from 'modules/Forms/Account/Create/TwoGis'
import AdGod, { AdGodSchema } from 'modules/Forms/Account/Create/AdGod'
import SberAds, { SberAdsSchema } from 'modules/Forms/Account/Create/SberAds'
import AvitoAds, { AvitoAdsSchema } from 'modules/Forms/Account/Create/AvitoAds'

export default {
  avito: { component: Avito, schema: AvitoSchema },
  facebook: { component: Facebook, schema: FacebookSchema },
  'facebook-high-risk': {
    component: FacebookHighRisk,
    schema: FacebookHighRiskSchema,
  },
  yd: { component: Yandex, schema: YandexSchema },
  'yandex-business': {
    component: YandexBusiness,
    schema: YandexBusinessSchema,
  },
  vk: { component: Vk, schema: VkSchema },
  adsmarket: { component: Adsmarket, schema: AdsmarketSchema },
  targetmail: { component: TargetMail, schema: TargetMailSchema },
  'vk-ads': { component: VkAds, schema: VkAdsSchema },
  'yandex-zen': { component: YandexZen, schema: YandexZenSchema },
  directadvert: { component: DirectAdvert, schema: DirectAdvertSchema },
  zeropark: { component: Zeropark, schema: ZeroparkSchema },
  yahoo: { component: Yahoo, schema: YahooSchema },
  adgram: { component: Adgram, schema: AdgramSchema },
  otm: { component: Otm, schema: OtmSchema },
  snapchat: { component: Snapchat, schema: SnapchatSchema },
  pornhub: { component: Pornhub, schema: PornhubSchema },
  trafficjunky: { component: Pornhub, schema: PornhubSchema },
  mytargetint: { component: MytargetInt, schema: MytargetIntSchema },
  tiktok: { component: Tiktok, schema: TiktokSchema },
  taboola: { component: Taboola, schema: TaboolaSchema },
  'telegram-ads': { component: TelegramAds, schema: TelegramAdsSchema },
  'google-ads': { component: GoogleAds, schema: GoogleAdsSchema },
  'google-high-risk': {
    component: GoogleAdsHighRisk,
    schema: GoogleAdsHighRiskSchema,
  },
  'bigo-ads': { component: BigoAds, schema: BigoAdsSchema },
  mobidriven: { component: Mobidriven, schema: MobidrivenSchema },
  appnext: { component: Appnext, schema: AppnextSchema },
  'yandex-geoadv': { component: YandexGeo, schema: YandexGeoSchema },
  'ozon-performance': {
    component: OzonPerformance,
    schema: OzonPerformanceSchema,
  },
  'petal-ads': { component: PetalAds, schema: PetalAdsSchema },
  'mi-ads': { component: MiAds, schema: MiAdsSchema },
  'apple-search-ads': {
    component: AppleSearchAds,
    schema: AppleSearchAdsSchema,
  },
  'unity-ads': {
    component: UnityAds,
    schema: UnityAdsSchema,
  },
  'microsoft-advertising': {
    component: MicrosoftAds,
    schema: MicrosoftAdsSchema,
  },
  wowblogger: {
    component: WowBlogger,
    schema: WowBloggerSchema,
  },
  'vk-adblogger': {
    component: VkAdBlogger,
    schema: VkAdBloggerSchema,
  },
  'two-gis': {
    component: TwoGis,
    schema: TwoGisSchema,
  },
  'ad-god': {
    component: AdGod,
    schema: AdGodSchema,
  },
  'sber-ads': {
    component: SberAds,
    schema: SberAdsSchema,
  },
  'avito-ads': {
    component: AvitoAds,
    schema: AvitoAdsSchema,
  },
}
